import { render, staticRenderFns } from "./tonnage.vue?vue&type=template&id=0cf9c860&scoped=true&"
import script from "./tonnage.vue?vue&type=script&lang=js&"
export * from "./tonnage.vue?vue&type=script&lang=js&"
import style0 from "./tonnage.vue?vue&type=style&index=0&id=0cf9c860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9c860",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
